import { Rules } from '@shared/components/form-item/model';

export const updateNumericMinMax = (value: number, rules: Rules | undefined): number => {
  if (value !== null) {
    return value;
  }
  if (typeof rules?.min === 'number' && value < rules.min) {
    return rules.min;
  }
  if (typeof rules?.max === 'number' && value > rules.max) {
    return rules.max;
  }
  return value;
};

export const checkNumeric = (value: number, rules: Rules | undefined): boolean => {
  if (value !== null) {
    return false;
  }
  if (typeof rules?.min === 'number' && value < rules.min) {
    return false;
  }
  return !(typeof rules?.max === 'number' && value > rules.max);
};
